(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/transaction-history-row.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/transaction-history-row.js');

'use strict';

const _svs$ui$reactTable = svs.ui.reactTable,
  TableRow = _svs$ui$reactTable.TableRow,
  TableCell = _svs$ui$reactTable.TableCell;
const getTransactionTypeText = transaction => {
  const transactionMember = transaction.customer && transaction.customer.firstName ? "".concat(transaction.customer.firstName, " ").concat(transaction.customer.lastName) : 'Anonym kund';
  switch (transaction.transactionType) {
    case 'BET':
      return {
        text: "Spel ".concat(transaction.text),
        name: transactionMember,
        color: 'fc-red'
      };
    case 'CANCEL_BET':
      return {
        text: "Annullering ".concat(transaction.text),
        name: transactionMember,
        color: 'fc-navy'
      };
    case 'WITHDRAWAL':
      return {
        text: 'Uttag',
        name: transactionMember,
        color: 'fc-navy'
      };
    case 'DEPOSIT':
      return {
        text: 'Insättning',
        name: transactionMember,
        color: 'fc-navy'
      };
    case 'WIN':
      return {
        text: "Vinst ".concat(transaction.text),
        color: 'fc-green'
      };
    case 'REFUND':
      return {
        text: "\xC5terbetalning ".concat(transaction.text),
        color: 'fc-navy'
      };
    case 'REJECTED_DEPOSIT':
      return {
        text: 'Avvisad insättning',
        name: transactionMember,
        color: 'fc-navy'
      };
    default:
  }
};

const TransactionHistoryRow = _ref => {
  let transRow = _ref.transRow;
  const date = dateFns.format(dateFns.parseISO(transRow.transactionTime), 'yyyy-MM-dd');
  const time = dateFns.format(dateFns.parseISO(transRow.transactionTime), 'HH:mm');
  const _getTransactionTypeTe = getTransactionTypeText(transRow),
    text = _getTransactionTypeTe.text,
    name = _getTransactionTypeTe.name,
    color = _getTransactionTypeTe.color;
  const amount = "".concat(svs.utils.format.Currency(transRow.transactionAmount, false), " kr");
  return React.createElement(TableRow, null, React.createElement(TableCell, {
    className: "u-align-top"
  }, React.createElement("div", {
    className: "padding-xs-v"
  }, date, svs.core.detect.breakpoint.equals('xs') ? React.createElement("br", null) : ' ', time)), React.createElement(TableCell, {
    className: "u-align-top transaction-history-table-column-text"
  }, React.createElement("div", {
    className: "padding-xs-v overflow-threedots"
  }, text, React.createElement("br", null), React.createElement("span", {
    className: "data-hj-suppress"
  }, name))), React.createElement(TableCell, {
    className: "u-align-top f-right ".concat(color)
  }, React.createElement("div", {
    className: "padding-xs-v"
  }, amount)));
};
svs.arena.pages.teams.components.TransactionHistoryRow = TransactionHistoryRow;

 })(window);